export default __webpack_public_path__ + "static/media/welcome-tour-4-mob.6f55aa43.png";